import { render, staticRenderFns } from "./FluxoAtendimentos.vue?vue&type=template&id=64a4f13a&"
import script from "./FluxoAtendimentos.vue?vue&type=script&lang=js&"
export * from "./FluxoAtendimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports